import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';
import { borderRadius, mediaMax, spacing } from 'presentations/views/styles';
import styled from '@emotion/styled';
import SectionTitle from 'presentations/views/components/molecules/ServiceSectionTitle';
import Button from 'presentations/views/components/atoms/Button';
import { customerStoryListPath } from 'presentations/routes/path';
import CustomerListItem from 'presentations/views/components/molecules/CustomerStoryListItem';
import { CustomerStoryListItem } from 'presentations/api/schema/contents';

interface Props {
  customers: CustomerStoryListItem[];
}

export default function Component(props: Props) {
  const t = translateInComponent(translations);
  return (
    <>
      <SectionTitle
        title={t('title')}
        // titleEn={t('title en')}
        description={t('description')}
      />
      <CustomerList count={props.customers.length}>
        {props.customers.map((customer) => (
          <CustomerListItemWrap key={customer.id}>
            <CustomerListItem customer={customer} />
          </CustomerListItemWrap>
        ))}
      </CustomerList>
      <More>
        <Button color="primary" size="large" href={customerStoryListPath()}>
          {t('more')}
        </Button>
      </More>
    </>
  );
}
const CustomerList = styled.div<{ count: number }>`
  display: grid;
  grid-template-columns: ${(props) => `repeat(${props.count}, 1fr)`};
  column-gap: ${spacing(16)};
  row-gap: ${spacing(16)};
  margin-top: ${spacing(48)};
  ${mediaMax.tablet} {
    display: block;
  }
`;

const More = styled.div`
  margin-top: ${spacing(32)};
  text-align: center;
`;

const CustomerListItemWrap = styled.div`
  border-radius: ${borderRadius(16)};
  overflow: hidden;
  ${mediaMax.tablet} {
    margin-bottom: ${spacing(24)};
    :last-child {
      margin-bottom: 0;
    }
  }
`;
